import { useState } from 'react';
import { DesktopOnlyNotice } from '../components/ui';

/**
 * The GL feed. Downloading commits the export (stamping
 * exported_to_accounting_at), previewing does not -- so finance can look
 * without accidentally marking a month as posted.
 */
export function AccountingExportPage() {
  const today = new Date().toISOString().slice(0, 10);
  const [from, setFrom] = useState(today.slice(0, 8) + '01');
  const [to, setTo] = useState(today);
  const [status, setStatus] = useState<'approved' | 'paid'>('approved');
  const [includeExported, setIncludeExported] = useState(false);

  function url(commit: boolean): string {
    const params = new URLSearchParams({
      from, to, status,
      includeAlreadyExported: String(includeExported),
      ...(commit ? { commit: 'true' } : {}),
    });
    return `/api/exports/accounting?${params.toString()}`;
  }

  return (
    <div className="max-w-2xl">
      <h1 className="mb-4 text-xl font-semibold">Accounting export</h1>
      <DesktopOnlyNotice />

      <div className="card space-y-4 p-4">
        <div className="grid gap-3 sm:grid-cols-2">
          <div>
            <label className="label" htmlFor="from">From</label>
            <input id="from" type="date" className="field" value={from} onChange={(e) => setFrom(e.target.value)} />
          </div>
          <div>
            <label className="label" htmlFor="to">To</label>
            <input id="to" type="date" className="field" value={to} onChange={(e) => setTo(e.target.value)} />
          </div>
        </div>

        <div>
          <label className="label" htmlFor="status">Report status</label>
          <select id="status" className="field" value={status}
                  onChange={(e) => setStatus(e.target.value as 'approved' | 'paid')}>
            <option value="approved">Approved</option>
            <option value="paid">Paid</option>
          </select>
        </div>

        <label className="flex min-h-11 items-center gap-3">
          <input type="checkbox" className="h-5 w-5" checked={includeExported}
                 onChange={(e) => setIncludeExported(e.target.checked)} />
          <span className="text-sm">Include reports already exported once</span>
        </label>

        <p className="text-sm text-slate-500">
          One row per line item, with the GL code recorded on each line at approval time.
          Downloading marks these reports as exported so they are not posted twice.
        </p>

        <div className="flex gap-2">
          <a className="btn-secondary" href={url(false)} target="_blank" rel="noreferrer">Preview (no stamp)</a>
          <a className="btn-primary" href={url(true)}>Download CSV</a>
        </div>
      </div>
    </div>
  );
}
